<template>
  <div
    class="d-flex-column justify-start align-start gap-60"
    style="margin-top: 30px; margin-bottom: 30px"
  >
    <ContactBanner />

    <div
      class="d-flex-row space-between lg-row-to-col gap-48"
      style="margin-top: 30px"
    >
      <div class="d-flex-column contact_card flex-5 gap-12">
        <CornerArrow class="top-left" />
        <CornerArrow class="top-right" />
        <CornerArrow class="bottom-left" />
        <CornerArrow class="bottom-right" />

        <img
          src="/images/contact_us/support_chat.webp"
          alt="Contact card image"
          height="90"
          width="90"
          class="contact_card_image"
        />
        <h5 class="t-white font-family-1 regular-xxxl f-w-600">
          {{ $t("contact.support_chat") }}
        </h5>
        <p class="t-light regular-xl font-family-2">
          {{ $t("contact.support_chat_desc") }}
        </p>
        <button
          href="javascript:;"
          @click.stop="handleTidio"
          class="primary outlined-color xl height-48 full-width max-width-213px b-radius-9 regular-l f-w-600 font-family-1"
          style="margin-top: 12px"
        >
          {{ $t("contact.lets_chat") }}
        </button>
      </div>

      <div class="d-flex-column contact_card flex-5 gap-12">
        <CornerArrow class="top-left" />
        <CornerArrow class="top-right" />
        <CornerArrow class="bottom-left" />
        <CornerArrow class="bottom-right" />

        <img
          src="/images/contact_us/partnership.webp"
          alt="Contact card image"
          height="90"
          width="90"
          class="contact_card_image"
        />
        <h5 class="t-white font-family-1 regular-xxxl f-w-600">
          {{ $t("contact.partnership") }}
        </h5>
        <p class="t-light regular-xl font-family-2">
          {{ $t("contact.partnership_desc") }}
        </p>
        <a
          href="mailto:info@boostingmarket.com"
          target="_blank"
          rel="noreferrer"
          class="primary outlined-color xl height-48 full-width max-width-213px b-radius-9 regular-l f-w-600 font-family-1"
          style="margin-top: 12px"
        >
          {{ $t("contact.become_partner") }}
        </a>
      </div>
    </div>

    <ContactForm />
  </div>
</template>

<script setup>
import ContactBanner from "../components/banners/ContactBanner.vue";
import CornerArrow from "~/components/icons/CornerArrow.vue";
import ContactForm from "~/components/forms/ContactForm.vue";
// import VueTidio from "vue-tidio";
const { t } = useI18n();
const router = useRouter();
const route = router.currentRoute;
const nuxtApp = useNuxtApp();
const { public: publicConfig, nuxtEnv } = useRuntimeConfig();
const { isCrispLoaded, openChat, initializeCrisp } = useCrispComposable();
definePageMeta({
  layout: "default",
  pageInfo: {
    name: "contact",
  },
});
useSeoMeta({
  title: t("contact.meta.title"),
  description: t("contact.meta.description"),
});
addCanonicalLink(route.value.fullPath);
const userStore = useUserStore();

const handleTidio = () => {
  if (isCrispLoaded()) {
    openChat();
  } else {
    initializeCrisp();
    openChat();
  }
};

onNuxtReady(() => {
  const query = route.value.query;
  if (query?.chat_support) {
    handleTidio();
  }
});
</script>